import React from 'react'
import styled from 'styled-components'

const sameKey = (list, name) => Object.keys(
    list.reduce(
      (tally, {[name]: current}) =>
        ({...tally, [current]: true}), {}
    )
  ).length

const Text = styled.span`
  color: #8C8C8C;
  font-weight: lighter;
  font-size: 1.5rem;
  padding-right: 20px;
`

const Counter = ({positions, filter}) =>
    <h2 className="text-center mt-3">
        {positions.length} <Text>Positions</Text>
        {sameKey(positions, 'location')} <Text>Locations</Text>
        {sameKey(positions, 'company')} <Text>Companies</Text>
    </h2>
export default Counter



// WEBPACK FOOTER //
// ./src/components/counter.js